import SectionTitle from './SectionTitle';

export default function AboutSection() {
  return (
    <>
      <SectionTitle>ABOUT THIS APP</SectionTitle>
      <div className="px-4 pb-5 text-sm text-gray-700 leading-relaxed">
        Embark on a glittering adventure with our latest slot sensation - "Jackpot Reels"! 
        Immerse yourself in the thrill of the game...
      </div>
    </>
  );
}